module.exports = __webpack_public_path__ + "static/media/house-flood.d35c699b.svg";